import React from 'react';
import { footerLinks } from '../constants';
import {BsYoutube, BsInstagram} from "react-icons/bs"
import {BiLogoFacebook} from "react-icons/bi"

const Footer = () => {
  return (
    <footer className='text-black w-full px-0'>
      <div className="flex justify-center flex-wrap gap-[30px] mb-[20px] items-center">
      <a href="/" className= "cursor-pointer">
            <img src='/logo.png' alt='logo' />
        </a>
        <div className="flex gap-[15px] cursor-pointer">
        <a href="/" className= "cursor-pointer flex items-center bg-white rounded-full">
            <BsYoutube size={30} color='red'/>
        </a>
        <a href="/" className= "cursor-pointer flex items-center bg-white rounded-full">
            <BsInstagram size={26} />
        </a>
        <a href="/" className= "cursor-pointer flex items-center bg-white rounded-full">
            <BiLogoFacebook size={30} color='blue'/>
        </a>
        </div>
      </div>
      <div className='w-full flex flex-col sm:flex-row justify-between gap-5 sm:p-5 p-6 py-5'>
        <div className='flex flex-col items-start gap-6'>
          <img src='/logo.png' alt='logo' className='object-contain' />
          <p className='text-base text-gray-700'>
            KFC 2023 <br />
            All Rights Reserved &copy;
          </p>
        </div>

        <div className='flex flex-row gap-5'>
          {footerLinks.map((item) => (
            <div key={item.title}>
              <h3 className='font-bold'>{item.title}</h3>
              <div className='flex flex-col gap-5'>
                {item.links.map((link) => ( 
                  <a key={link.title} href={link.url} className='text-gray-500'>
                  {link.title}
                   </a>
                 ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='mx-auto flex justify-between items-center flex-wrap sm:p-5 px-6 border-t border-gray-100'>
        <p>&copy; 2023 KFC. All rights reserved</p>

        <div className='flex gap-5'>
          <a href="/privacy">
            Privacy & Policy
          </a>
          <a href="/terms">
            Terms & Conditions
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
